import { render, staticRenderFns } from "./SetBulkItems.vue?vue&type=template&id=8b31861c&scoped=true"
import script from "./SetBulkItems.vue?vue&type=script&lang=js"
export * from "./SetBulkItems.vue?vue&type=script&lang=js"
import style0 from "./SetBulkItems.vue?vue&type=style&index=0&id=8b31861c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b31861c",
  null
  
)

export default component.exports